import { projectRunner2Text, scriptExitMechanismCode } from './projectRunner2.script'
import { extractUsedTypes, createLibScript, LibPathKey } from './extractDependencies'
import { Log } from '@fanfanlo'

const fileLog = new Log(false, 'assembleProjectScript')
fileLog.pause = true;
fileLog.childrenPaused = true;
/**
 * Logger 初始化代码
 */
const libLoggerCode = `
console.paused = false;
let javaLibInitLogger = console.subLogger("lib9");
let projectStoreLogger = javaLibInitLogger.subLogger("store9");
let projectEventLogger = console.subLogger("event9");
let projectFailedLogger = console.subLogger("failed9");
let projectFlowLogger = console.subLogger("flow9");
projectFlowLogger.paused = false;
projectStoreLogger.paused = false;
`

/**
 * onLibReady 机制代码
 */
const libHeaderCode = `
const onLibReadyInitFuncs = [];
function onLibReady(f, info){
    console.log('reg onLiReady', info);
    onLibReadyInitFuncs.push({f, info});
}
`

/**
 * 执行所有 onLibReady 回调
 */
const libFooterCode = `
for(let i = 0; i < onLibReadyInitFuncs.length; i++){
    let data = onLibReadyInitFuncs[i];
    try{
        data.f();
    }catch(e){
        console.log("on lib ready init fun error", data.info, e);
    }
}
`

/**
 * 组装 Project 执行脚本
 *
 * 将 projectRunner2.js 引擎、javaLib 依赖和 IProjectData 数据组合成完整的可执行脚本
 *
 * @param projectData - Project 数据对象
 * @returns 完整的可执行 JavaScript 脚本
 *
 * @example
 * const script = assembleProjectScript(myProject)
 * // script 可以直接在 Rhino 环境中执行
 * IProjectData 不应该在这里引入，这个方法可能就不应该在当前这个库里。
 */
export function assembleProjectScript(projectData: IProjectData): string {
    fileLog.log('[assembleProjectScript] ========== 开始组装脚本 ==========')
    fileLog.log('[assembleProjectScript] projectData.client_id:', projectData.client_id)
    fileLog.log('[assembleProjectScript] projectData.name:', projectData.name)

    // 1. 提取使用的 Trigger 和 Action types
    fileLog.log('[assembleProjectScript] 步骤 1: 提取依赖类型')
    const usedTypes = extractUsedTypes(projectData)
    fileLog.log('[assembleProjectScript] 使用的类型数量:', usedTypes.size)
    fileLog.log('[assembleProjectScript] 类型列表:', Array.from(usedTypes))

    if (usedTypes.size === 0) {
        fileLog.log('[assembleProjectScript] 警告: 没有找到任何 Trigger 或 Action 类型')
    }

    // 2. 创建 javaLib 对象（包含所有依赖）
    fileLog.log('[assembleProjectScript] 步骤 2: 创建 javaLib 对象')
    const javaLibScript = createLibScript(Array.from(usedTypes) as LibPathKey[])
    fileLog.log('[assembleProjectScript] javaLib 脚本长度:', javaLibScript.length)

    // 3. 组装完整脚本
    fileLog.log('[assembleProjectScript] 步骤 3: 组装完整脚本')
    const script = `
${libLoggerCode}
;
${libHeaderCode}
;
${scriptExitMechanismCode}
;
${javaLibScript}
;
${libFooterCode}
;
${projectRunner2Text}
;
// ========================================
// 执行入口
// ========================================
var initData = ${JSON.stringify(projectData, null, 2)};
projectBuilder(initData);
`
    fileLog.log('[assembleProjectScript] 脚本组装完成')
    fileLog.log('[assembleProjectScript] 总脚本长度:', script.length)
    fileLog.log('[assembleProjectScript] ========== 组装完成 ==========')

    return script
}
